var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Las estaciones","audio2":"../mp3/PrimariaF/03PF.mp3","cover":"../img/6.jpg","name":"Primaria F - Lección #3"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }